if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this._zoomCache = new Map();
        this._zoomGeneration = 0;
        if (!window.matchMedia('(max-width: 749px)').matches) this.loadZoomImages();
      }

      hide() {
        this._zoomGeneration++;
        super.hide();
      }

      loadZoomImages() {
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        this.querySelectorAll('img[data-zb-zoom-srcset]').forEach((image) => {
          if (mobile) {
            const preview = document.querySelector('media-gallery [data-media-id$="-' + image.dataset.mediaId + '"] .product__media img');
            if (preview) {
              image.dataset.zbFullZoomSrc = image.dataset.zbZoomSrc;
              image.sizes = preview.sizes;
              image.srcset = preview.srcset;
              image.src = preview.currentSrc || preview.src;
            } else {
              image.srcset = image.dataset.zbZoomSrcset;
              image.src = image.dataset.zbZoomSrc;
            }
          } else {
            image.srcset = image.dataset.zbZoomSrcset;
            image.src = image.dataset.zbZoomSrc;
          }
          image.removeAttribute('data-zb-zoom-srcset');
          image.removeAttribute('data-zb-zoom-src');
        });
      }

      loadFullZoom(url) {
        if (!this._zoomCache.has(url)) {
          this._zoomCache.set(url, new Promise((resolve, reject) => {
            const full = new Image();
            full.decoding = 'async';
            full.fetchPriority = 'low';
            full.onload = async () => {
              try { await full.decode(); } catch (_) {}
              resolve(full);
            };
            full.onerror = () => { this._zoomCache.delete(url); reject(new Error('zoom image')); };
            full.src = url;
          }));
        }
        return this._zoomCache.get(url);
      }

      async prefetchAdjacent(image, generation) {
        const images = Array.from(this.querySelectorAll('img[data-zb-full-zoom-src]'));
        const index = images.indexOf(image);
        const adjacent = [images[index + 1], images[index - 1], images[index + 2]]
          .filter(Boolean).slice(0, 2);
        for (const neighbor of adjacent) {
          if (!this.hasAttribute('open') || generation !== this._zoomGeneration) return;
          try {
            const full = await this.loadFullZoom(neighbor.dataset.zbFullZoomSrc);
            if (!this.hasAttribute('open') || generation !== this._zoomGeneration) return;
            neighbor.removeAttribute('srcset');
            neighbor.src = full.src;
          } catch (_) {}
        }
      }

      upgradeZoom(image) {
        const url = image.dataset.zbFullZoomSrc;
        if (!url) return;
        const generation = ++this._zoomGeneration;
        this.loadFullZoom(url).then((full) => {
          if (!this.hasAttribute('open') || generation !== this._zoomGeneration || !image.classList.contains('active')) return;
          image.removeAttribute('srcset');
          image.src = full.src;
          this.prefetchAdjacent(image, generation);
        }).catch(() => {});
      }

      show(opener) {
        this.loadZoomImages();
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        if (activeMedia.tagName === 'IMG') {
          activeMedia.loading = 'eager';
          if (window.matchMedia('(max-width: 749px)').matches) this.upgradeZoom(activeMedia);
        }
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

